export const ConsumerSubmitViewUat = {
  instructions: 'workflow.consumerSubmit.instructions'
}
